module.exports = __webpack_public_path__ + "static/media/gallery_01_thumb.1bf21c80.jpg";